import {styled, mq} from '../../../utils';
import Layout from '../../Layout';

const momentumScrollingStyles = {
  overflowY: 'scroll',
  WebkitOverflowScrolling: 'touch'
};

export default styled(Layout)({
  [mq('phone')]: momentumScrollingStyles,
  [mq('tablet')]: momentumScrollingStyles,
  [mq('laptopAndUp')]: {
    overflow: 'auto',
    height: '100vh'
  }
  // tslint:disable-next-line:no-any
} as any);



// WEBPACK FOOTER //
// ./src/components/AuthLayout/MainContainer/MainContainer.tsx